import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const pageTitles = {
  '/dashboard': 'Dashboard',
  '/users':     'Users',
  '/analytics': 'Analytics',
  '/reports':   'Reports',
  '/settings':  'Settings',
};

function TopNavbar({ darkMode, onToggleDark }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const title = pageTitles[location.pathname] || 'Dashboard';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="top-navbar">
      <span className="navbar-page-title">{title}</span>
      <div className="navbar-right">
        <button className="dark-toggle-btn" onClick={onToggleDark}>
          {darkMode ? '☀ Light Mode' : '☾ Dark Mode'}
        </button>
        {user && (
          <div className="user-info">
            <img src={user.picture} alt={user.name} className="user-avatar" referrerPolicy="no-referrer" />
            <span className="user-name">{user.name}</span>
            <button className="logout-btn" onClick={handleLogout}>Sign out</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopNavbar;
